(function () {
  /**
   * @ngdoc provider
   * @name apiReady
   * @description defines invitesReady provider to configure invite state
   */
  angular.module('app.core.invites.ready').provider('invitesReady', invitesReadyProvider);

  /* @ngInject */
  function invitesReadyProvider(_) {
    this.$get = $get;

    /* @ngInject */
    function $get(
      $injector,
      $location,
      $log,
      $q,
      apiReady,
      authentication,
      authenticationReady,
      featureReady,
      BlackoutError,
      invitesStorage,
      INVITATION_STATUS,
      INVITATION_TYPE,
      Redirector
    ) {
      const runDeferred = $q.defer();
      return {
        run,
        whenRunReady,
      };

      ////////////

      function run() {
        const cachedInvitationCode = invitesStorage.getCachedInviteCode();
        if (cachedInvitationCode) {
          completeInviteAccept(cachedInvitationCode);
        } else if (_.startsWith($location.path(), '/invitation/')) {
          checkForInvite();
        } else {
          runDeferred.resolve();
        }
      }

      function checkForInvite() {
        const invitationCode = _.trimStart($location.path(), '/invitation/');
        $q.all([
          apiReady.whenRunReady(),
          authenticationReady.whenRunReady(),
          featureReady.whenRunReady(),
        ])
          .then(() => {
            // we fetch this lazily to ensure that the API paths are configured
            const Invitation = $injector.get('Invitation');
            const invitation = Invitation.get(invitationCode);
            return invitation.$promise;
          })
          .then((invitation) => {
            $log.info('%cInvitation details ::', 'font-weight:bold;color:#009966;', invitation);

            if (invitation.status === INVITATION_STATUS.ACTIVE) {
              // Persist invitation details so it lives between redirects
              invitesStorage.setCachedInviteCode(invitationCode);

              const apiParams = {
                puser: invitation.email,
              };
              // If the invitation type is not forwardable, disable the email field
              if (!INVITATION_TYPE[invitation.typeCode].forwardable) {
                apiParams.eu = true;
              }

              apiParams.idp_flow = 'create_account';
              apiParams.dc = false; // show Create Account button
              apiParams.el = true; // show Sign In button (to let them sign in as an existing user)

              authentication.signIn(apiParams);
            } else if (invitation.status === INVITATION_STATUS.CLAIMED) {
              $log.info('%cInvitation already claimed.', 'font-weight:bold;color:#009966;');

              // Log out user, after that, redirect to login is automatic.
              // As the invitation was already claimed, the login should just take the user to the right page.
              Redirector.go('logout', true);
            } else {
              // Expired, Reovked (and such) invitations
              $log.info('%cInvitation is expired.', 'font-weight:bold;color:#009966;');

              BlackoutError.showExpiredInvitationError();
            }
          })
          .catch((error) => {
            $log.warn(error);
            $log.info(
              '%cInvitation details could not be fetched or invalid invitation.',
              'font-weight:bold;color:#009966;'
            );

            BlackoutError.showGenericError();
          })
          .finally(() => {
            runDeferred.resolve();
          });

        return runDeferred.promise;
      }

      function completeInviteAccept(invitationCode) {
        $q.all([apiReady.whenRunReady(), authenticationReady.whenRunReady()])
          .then(() => {
            // we fetch this lazily to ensure that the API paths are configured
            const Invitation = $injector.get('Invitation');
            $log.info(
              '%cSessionStorage invitation detected ::',
              'font-weight:bold;color:#009966;',
              invitationCode
            );

            invitesStorage.removeCachedInviteCode();

            const invitation = new Invitation({invitationCode});
            return invitation.accept();
          })
          .then(() => {
            $log.info('%cInvitation was successfully claimed.', 'font-weight:bold;color:#009966;');

            Redirector.go('login');
          })
          .catch(() => {
            $log.info(
              '%cInvitation code is invalid or does not match user credentials.',
              'font-weight:bold;color:#009966;'
            );

            // If there was a problem with the invitation, log the user out
            // This can happen if invitation code is invalid or invitation status is not ACTIVE
            // or if the invitation doesn't belong to the user logged in.
            Redirector.go('logout');
          })
          .finally(() => {
            runDeferred.resolve();
          });

        return runDeferred.promise;
      }

      function whenRunReady() {
        return runDeferred.promise;
      }
    }
  }
})();
